import React, { Fragment, useEffect, useState } from 'react'
import AdverSec from '../../adverSec/AdverSec'
import Autocomplete from "react-google-autocomplete";
// import { UsePlaceAuth } from '../../../../../AppContext/AppContext';
import AppPromo from '../../appPromo/AppPromo';
import OwlCarousel from 'react-owl-carousel';
import { apiData } from '../../../../../actions';
import { useLocation } from 'react-router-dom';
import offer1 from "../../../../../demo/offer1.png"
import offer2 from "../../../../../demo/offer2.png"
import offer3 from "../../../../../demo/offer3.png"
import { useDispatch, useSelector } from 'react-redux';
import { Hotel } from '../../../../../Redux/Action/Action';
function Hotels() {
	let location = useLocation();
	const [loader, setLoader] = useState(false);
	const [loading, setLoading] = useState(true);
	const [dealsData, setDealsData] = useState([]);
	const [relaxingData, setRelaxingData] = useState([]);
	// let [selectedplace, setSelectedPlace] =useState("")
	const place = useSelector(state => state.place)
	const dispatch = useDispatch();
	// const { active, setActive } = UsePlaceAuth()

	useEffect(() => {
  const handlePageShow = () => {
    setLoader(false);
  };

  window.addEventListener('pageshow', handlePageShow);
  window.addEventListener('popstate', handlePageShow);

  return () => {
    window.removeEventListener('pageshow', handlePageShow);
    window.removeEventListener('popstate', handlePageShow);
  };
}, []);

	const handleLinkClick = (e) => {
		e.preventDefault();
		const targetUrl = e.currentTarget.getAttribute('href'); // get href of clicked link
		setLoader(true);

		setTimeout(() => {
			window.location.href = targetUrl;
		}, 1000);
	};
	const GetCities = async () => {
		setLoader(true);
		let apiRes = await apiData.RelaxingCities();
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setRelaxingData(apiRes?.data?.data);
			setLoader(false);
		}
		if (apiRes?.status >= 400 && apiRes?.status <= 500) {
			console.log("error");
		}
	};
	const GetDeals = async () => {
		let payload = {
			city: place,
			keyword: "All-Inclusive",
			limit: 12
		};
		setLoader(true)
		let apiRes = await apiData.getRandomDeals(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setDealsData(
				apiRes?.data?.data?.data?.travelExperienceProducts?.resultList
			);
			setLoader(false);
		}
		if (apiRes?.status >= 400 && apiRes?.status <= 500) {
			console.log("error");
		}
	};
	useEffect(() => {
		GetCities();
		GetDeals()
	}, [])
	var settings1 = {
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 499,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	};

	useEffect(() => {
		dispatch(Hotel());

		const existingScript = document.querySelector('script[src*= "https://tp.media/content?trs=26480&shmarker=130544&show_hotels=false&powered_by=false&locale=en&currency=usd&searchUrl=travel.mysittivacations.com/hotels&color_button=%23196AE1&color_icons=%23196AE1&secondary=%23FFFFFF&dark=%23262626&light=%23FFFFFF&special=%23C4C4C4&color_focused=%23196ae1&border_radius=5&plain=true&promo_id=7873&campaign_id=101"]');

		const waitForWidget = () => {
			const checkInterval = setInterval(() => {
				const loadedEl = document.querySelector('.cascoon-tabs-button--active');
				if (loadedEl) {
					setLoading(false);
					clearInterval(checkInterval);
				}
			}, 300);

			setTimeout(() => {
				clearInterval(checkInterval);
				setLoading(false);
			}, 100);
		};

		if (!existingScript) {
			const script = document.createElement('script');
			script.src =
				"https://tp.media/content?trs=26480&shmarker=130544&show_hotels=false&powered_by=false&locale=en&currency=usd&searchUrl=travel.mysittivacations.com/hotels&color_button=%23196AE1&color_icons=%23196AE1&secondary=%23FFFFFF&dark=%23262626&light=%23FFFFFF&special=%23C4C4C4&color_focused=%23196ae1&border_radius=5&plain=true&promo_id=7873&campaign_id=101";
			script.id = "tpHotelScript";

			script.onload = () => {
				waitForWidget();
			};

			script.onerror = () => setLoading(false);

			document.getElementById("hotelSearch")?.appendChild(script);
		} else {
			waitForWidget(); // widget may already be injected
		}

		return () => {
			const existingScript = document.getElementById("tpHotelScript");
			if (existingScript) {
				existingScript.remove();
			}

			const hotelEl = document.getElementById("hotelSearch");
			if (hotelEl) {
				hotelEl.innerHTML = "";
			}
		};
	}, []);
	return (
		<Fragment>
			<div className="hotels-banner-section rest-sec">
				<div id="hotelSearch" className="hotel-search-container">
				</div>
			</div>
			<AdverSec />
			<div className="offer-section">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-12">
							<div className="testimonial-section products">
								<div id="ProductSlide">
									<OwlCarousel {...settings1}>
										<div data-aos="zoom-in-right" className="testimonial-block product">
											<div className="cities">
												<img loading="lazy" src={offer1} alt="offers" />
												<div className="offer-details">
													<h3>Grab Up to $120 OFF on International Flights</h3>
													<p>With stamp-that-Passport Sale!</p>
												</div>
												<div className="offer-action">
													<a href="#/">Book Now</a>
													<a href="#/">T&C’s Apply</a>
												</div>
											</div>
										</div>
										<div data-aos="zoom-in-left" className="testimonial-block product">
											<div className="cities">
												<img loading="lazy" src={offer2} alt="offers" />
												<div className="offer-details">
													<h3>Grab Up to $120 OFF on International Flights</h3>
													<p>With stamp-that-Passport Sale!</p>
												</div>
												<div className="offer-action">
													<a href="#/">Book Now</a>
													<a href="#/">T&C’s Apply</a>
												</div>
											</div>
										</div>
										<div data-aos="zoom-in-right" className="testimonial-block product">
											<div className="cities">
												<img loading="lazy" src={offer3} alt="offers" />
												<div className="offer-details">
													<h3>Grab Up to $120 OFF on International Flights</h3>
													<p>With stamp-that-Passport Sale!</p>
												</div>
												<div className="offer-action">
													<a href="#/">Book Now</a>
													<a href="#/">T&C’s Apply</a>
												</div>
											</div>
										</div>
										<div data-aos="zoom-in-left" className="testimonial-block product">
											<div className="cities">
												<img loading="lazy" src={offer1} alt="offers" />
												<div className="offer-details">
													<h3>Grab Up to $120 OFF on International Flights</h3>
													<p>With stamp-that-Passport Sale!</p>
												</div>
												<div className="offer-action">
													<a href="#/">Book Now</a>
													<a href="#/">T&C’s Apply</a>
												</div>
											</div>
										</div>
									</OwlCarousel>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="offer-section">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
							<div className="header-sec">
								<h2>Cruise Deals</h2>
							</div>
						</div>
						<div className="col-12 col-lg-12">
							<div className="testimonial-section products">
								<div id="travel-slider">
									<OwlCarousel {...settings1}>
										<div className="testimonial-block product">
											<div className="cities travel">
												<img loading="lazy" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/last-minute-cruises.jpg`} alt="Last-minute" />
												<div className="offer-action">
													<a href="https://www.tkqlhce.com/click-8265264-10493749" onClick={handleLinkClick}>Last-minute</a>
												</div>
											</div>
										</div>
										<div className="testimonial-block product">
											<div className="cities travel">
												<img loading="lazy" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/family-cruises.jpg`} alt="Family" />
												<div className="offer-action">
													<a href="https://www.kqzyfj.com/click-8265264-10678374" onClick={handleLinkClick}>Family</a>
												</div>
											</div>
										</div>
										<div className="testimonial-block product">
											<div className="cities travel">
												<img loading="lazy" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/honeymoon.png`} alt="Honeymoon" />
												<div className="offer-action">
													<a href="https://www.jdoqocy.com/click-8265264-10281267" onClick={handleLinkClick}>Honeymoon</a>
												</div>
											</div>
										</div>
										<div className="testimonial-block product">
											<div className="cities travel">
												<img loading="lazy" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/ncl_Bliss_Haven_Observ_Lounge_Dk17_Sofa_View.jpg`} alt="Couple" />
												<div className="offer-action">
													<a href="https://www.anrdoezrs.net/click-8265264-13312047" onClick={handleLinkClick}>Couple</a>
												</div>
											</div>
										</div>
										{/* <div className="testimonial-block product">
											<div className="cities travel">
												<img loading="lazy" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/ncl_Bliss_Haven_Observ_Lounge_Dk17_Sofa_View.jpg`} alt="Couple" />
												<div className="offer-action">
													<a href="https://www.anrdoezrs.net/click-8265264-13312047">Couple</a>
												</div>
											</div>
										</div> */}
									</OwlCarousel>

								</div>
							</div>
							{loader && (
								<div className="loader-overlay">
									<div className="spinner"></div>
								</div>
							)}
						</div>


						{
							location.pathname === `/hotels/${place}` ? "" :
								<>
									<div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
										<div className="header-sec">
											<h2>Amazing All-Inclusive Discounts</h2>
										</div>
									</div>
									<div className="slider-section discount-section stay-sec comn-div family-sec">
										<div className="container">
											<div className="row">
												<OwlCarousel {...settings1}>
													{
														dealsData && dealsData?.map((ele) => {
															return (
																<div className="sliderDyDiv col-12 col-sm-6 col-md-4 col-lg-4 mb-4 p-0">
																	<div className="discount-block">
																		<img loading="lazy" src={ele?.imageLink} />
																		<div className="rating">
																			<div className="stars">
																				<div className="reviews-no">
																					<p>4.0</p>
																				</div>
																				<ul>
																					<li>
																						<i className="fa fa-star" aria-hidden="true"></i>
																					</li>
																					<li>
																						<i className="fa fa-star" aria-hidden="true"></i>
																					</li>
																					<li>
																						<i className="fa fa-star" aria-hidden="true"></i>
																					</li>
																					<li>
																						<i className="fa fa-star" aria-hidden="true"></i>
																					</li>
																				</ul>
																				{/* <p className="riview-last">
												<img loading="lazy" src="assets/images/searc.png" /> 0.29 mi from
												city center <img loading="lazy" src="assets/images/wifi.png" />
											</p> */}
																			</div>
																		</div>
																		<div className="discount-content">
																			<h3>{ele?.title}</h3>
																		</div>
																		<div className="discount-action hotels purple-bg city-price">
																			<div className="action-content">
																				<p>
																					<span>Price for 1 night</span>
																				</p>
																				<p>
																					<span className="old-price">$ {ele?.salePrice?.amount}</span>{" "}
																					<span className="new-price">${ele?.price?.amount}</span>{" "}
																					<span className="dis-percent">{Math.round(((Number(ele?.salePrice?.amount) - Number(ele?.price?.amount)) / Number(ele?.salePrice?.amount)) * 100)}%</span>
																				</p>
																			</div>
																			<a className="hotel-book" href={ele?.link}>
																				Book Now
																			</a>
																		</div>
																	</div>
																</div>
															)
														})
													}
												</OwlCarousel>
											</div>
										</div>
									</div>
								</>
						}


						<div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
							<div className="slider-sec">
								<h2>Relaxing Beach Gateways</h2>

							</div>
							<div className="col-12 col-lg-12">
								<div className="testimonial-section products">
									<div id="travel-slider">
										<OwlCarousel {...settings1}>
											{relaxingData &&
												relaxingData?.map((ele) => {
													return (
														<div className="testimonial-block product">
															<div className="discount-block">
																<a onClick={handleLinkClick} href={ele?.url}>
																	<img loading="lazy" src={`${ele?.image_url}`} alt="Beach-Gateways" />
																	{/* <img loading="lazy" src={require(`../../../${ele?.image_url}`)} alt="" /> */}
																	<div className="offer-action">
																		<a>{ele?.name}</a>
																	</div>
																</a>
															</div>
														</div>
													);
												})}
										</OwlCarousel>
									</div>
								</div>
								{loader && (
								<div className="loader-overlay">
									<div className="spinner"></div>
								</div>
							)}
							</div>
						</div>

					</div>
				</div>
			</div>
			<AppPromo />
			{/*
		  //Don't delete
		   <div className="rind-the-right-section comedy-sec hotels">
		  <div className="container">
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
					<div className="sidebar-listing">
						<div className="specialities-checkbox">
							<div className="searcher-sec">
								<label className="custom-control-label">Search By Name</label>
								<div className="form-group">
									<input type="Name" readOnly className="form-control" id="exampleFormControlInput1" placeholder={place}/>
								</div>
							</div>
						</div>
						<div className="specialities-checkbox">
							<div className="listing-check">
								<h4>ESTABLISHMENT TYPE</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck01"/>
								  <label className="custom-control-label" for="customCheck01">Restaurant</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck02"/>
								  <label className="custom-control-label" for="customCheck02">Quick Bites</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck03"/>
								  <label className="custom-control-label" for="customCheck03">Dessert</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck04"/>
								  <label className="custom-control-label" for="customCheck04">Coffee & Tea</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>RESTAURANT FEATURES</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck05"/>
								  <label className="custom-control-label" for="customCheck05">Delivery</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck06"/>
								  <label className="custom-control-label" for="customCheck06">Takeout</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck07"/>
								  <label className="custom-control-label" for="customCheck07">Gift Cards Available</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck08"/>
								  <label className="custom-control-label" for="customCheck08">Table Service</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck09"/>
								  <label className="custom-control-label" for="customCheck09">Accepts Credit Cards</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck10"/>
								  <label className="custom-control-label" for="customCheck10">Family style</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck11"/>
								  <label className="custom-control-label" for="customCheck11">Free Wifi</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>Meals</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck12"/>
								  <label className="custom-control-label" for="customCheck12">Breakfast</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck013"/>
								  <label className="custom-control-label" for="customCheck013">Brunch</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck14"/>
								  <label className="custom-control-label" for="customCheck14">Lunch</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck15"/>
								  <label className="custom-control-label" for="customCheck15">Dinner</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>CUISINE</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck16"/>
								  <label className="custom-control-label" for="customCheck16">American</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck17"/>
								  <label className="custom-control-label" for="customCheck17">Asian</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck18"/>
								  <label className="custom-control-label" for="customCheck18">Chinese</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck19"/>
								  <label className="custom-control-label" for="customCheck19">Australian</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>Price</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck20"/>
								  <label className="custom-control-label" for="customCheck20">Cheap Eats</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck21"/>
								  <label className="custom-control-label" for="customCheck21">Mid-range</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck22"/>
								  <label className="custom-control-label" for="customCheck22">Fine Dining</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>DISHES</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck23"/>
								  <label className="custom-control-label" for="customCheck23">Salad</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck24"/>
								  <label className="custom-control-label" for="customCheck24">Fish</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck25"/>
								  <label className="custom-control-label" for="customCheck25">Beef</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck26"/>
								  <label className="custom-control-label" for="customCheck26">Pork</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>GOOD FOR</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck23"/>
								  <label className="custom-control-label" for="customCheck23">Child-friendly</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck24"/>
								  <label className="custom-control-label" for="customCheck24">Kids</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck25"/>
								  <label className="custom-control-label" for="customCheck25">Bar Scene</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck26"/>
								  <label className="custom-control-label" for="customCheck26">Groups</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>DIETARY RESTRICTIONS</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck23"/>
								  <label className="custom-control-label" for="customCheck23">Vegetarian Friendly</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck24"/>
								  <label className="custom-control-label" for="customCheck24">Vegan Options</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck25"/>
								  <label className="custom-control-label" for="customCheck25">Halal</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck26"/>
								  <label className="custom-control-label" for="customCheck26">Kosher</label>
								</div>
							</div>
							<div className="listing-check">
								<h4>NEIGHBOURHOODS</h4>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck27"/>
								  <label className="custom-control-label" for="customCheck27">Downtown New York</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck28"/>
								  <label className="custom-control-label" for="customCheck28">Soma</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck29"/>
								  <label className="custom-control-label" for="customCheck29">Mission District</label>
								</div>
								<div className="custom-control custom-checkbox">
								  <input type="checkbox" className="custom-control-input" id="customCheck30"/>
								  <label className="custom-control-label" for="customCheck30">Theater District</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
					<div className="white-box-area inner rest-deals hotels">
						<div className="row">
							<div className="col-md-12 col-12">
								<div className="heading-content">
									<div className="content-sec">
										<p>Showing 4 of 257 places</p>
										<div className="custom-select-box">
											<span>Sort by </span>
										  <select className="form-select" aria-label="Default select example">
											  <option selected="">Recommended</option>
											  <option value="1">One</option>
											  <option value="2">Two</option>
											  <option value="3">Three</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-12 col-12">
								<section className="client-sec comedy">
									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio1.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>

									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio2.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>

									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio3.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>

									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio4.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>
									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio5.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>
									<div className="testimonial-section products">
										<div className="head-yelp hotels">
											<h3>Travelodge by Wyndham Memphis</h3>
											<div className="rev-top-sec">
												<p><span>4.2</span> <b>Very Good</b> 54 reviews</p>
											</div>
										</div>
										<div className="hotel-content-box">
											<div className="img-box">
												<img loading="lazy" src="images/audio6.png"/>
											</div>
											<div className="content-box">
												<p><i className="fa fa-map-marker" aria-hidden="true"></i> Memphis, Hall</p>
												<div className="hotel-review-sec">
													<div className="stars">
														<ul>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
															<li><i className="fa fa-star" aria-hidden="true"></i></li>
														</ul>
														<p>(339 Reviews)</p>
													</div>
													<div className="amentis">
														<p><i className="fa fa-coffee" aria-hidden="true"></i> 20+ Amenities</p>
													</div>
												</div>
												<div className="hotel-pricing">
													<p>starting from</p>
													<p className="price">$240<sub>/night</sub></p>
													<span>excl. tax</span>
												</div>
											</div>

										</div>
									</div>


								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div> */}
		</Fragment>
	)
}

export default Hotels